module.exports = __webpack_public_path__ + "static/media/Hagop Tozak.004b5438.png";